import * as React from 'react';
import { Jumbotron } from 'reactstrap';
import { compose, setDisplayName, toClass } from 'recompose';
import Alerts from '../../Alerts';
import {
    LoggedInUserProps,
    withLoggedInUser
} from '../../Login/withLoggedInUser';
import ActivityList from '../ActivityListScene/ActivityList';
import StravaLoginButton from '../StravaLoginButton';
import withDemoActivityList from './withDemoActivityList';

const ActivityListWithData = withDemoActivityList(ActivityList);

const StravaLoginMessage = withLoggedInUser(
    ({ loggedInUser, loading, error }: LoggedInUserProps) => {
        if (loggedInUser || loading || error) {
            return null;
        }

        return (
            <>
                <p className="lead">
                    Click below to connect with your own Strava account.
                </p>
                <StravaLoginButton />
            </>
        );
    }
);

export default compose(
    toClass,
    setDisplayName('DemoScene')
)(() => (
    <div className="demo-container">
        <Jumbotron>
            <h1>Example activities</h1>
            <p className="lead">
                Click on the rows below to see maps and charts of activities.
            </p>
            <StravaLoginMessage />
        </Jumbotron>
        <Alerts />
        <ActivityListWithData />
    </div>
));



// WEBPACK FOOTER //
// ./src/client/components/Strava/Demo/index.tsx